import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'dhhp-alert',
  templateUrl: './dhhpalert.component.html',
  styleUrls: ['./dhhpalert.component.scss']
})
export class DhhpAlertComponent implements OnInit {

  constructor(private _snackBar: MatSnackBar) { }

  dhhpAlertSystem(message: string, action: string) {
    this._snackBar.open(message, 'X', {
      panelClass: 'system-alert',
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 7000
    });
  }

  dhhpAlertStatus(message: string, action: string) {
    this._snackBar.open(message, 'X', {
      panelClass: 'status-alert',
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 7000
    });
  }

  dhhpAlertConfirmation(message: string, action: string) {
    this._snackBar.open(message, 'X', {
      panelClass: 'confirmation-alert',
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 7000
    });
  }

  dhhpAlertError(message: string, action: string) {
    this._snackBar.open(message, 'X', {
      panelClass: 'error-alert',
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 7000
    });
  }

  ngOnInit() {
  }

}